import React, { Fragment, useEffect } from "react";
import Header from "../Components/Reuseable/Header";
import Auth from "../Components/Reuseable/Auth";
import "../../Webiste/Components/CSS/pagesCSS/dashboard.css";
import Search from "../Components/Home/Components/Search";
import Tracker from "../Components/Home/Components/Tracker";
import Notification from "../Components/Home/Components/Notification";
import ExNews from "../Components/Home/Components/ExNews";
import Language from "../Components/Home/Components/Language";
import ScrollContainer from "react-indiana-drag-scroll";
import { useTranslation } from "react-i18next";
import { fetchsingleUser, STATUSES } from "../redux/getReducer/getSingleUser";
import { useDispatch, useSelector } from "react-redux";
import Lottie from "lottie-react";
import Animate from "../assets/loader.json";
import Cookies from "js-cookie";
import Moment from "react-moment";
import { truncateRaceType } from "../service/stringUtils";

import Footer from "../Components/Reuseable/Footer";
import Copyrights from "../Components/Reuseable/Copyrights";

const MySelection = () => {
  const { data: singleUser, status } = useSelector((state) => state.singleUser);
  const { t } = useTranslation();
  const cookiedata = Cookies.get("i18next");

  const dispatch = useDispatch();
  // const navigate = useNavigate();

  useEffect(() => {
    dispatch(fetchsingleUser());
  }, [dispatch]);

  if (status === STATUSES.LOADING) {
    return <Lottie animationData={Animate} className="load" />;
  }
  if (status === STATUSES.ERROR) {
    return (
      <h2
        style={{
          margin: "100px",
        }}
      >
        Something went wrong!
      </h2>
    );
  }

  return (
    <Fragment>
      {/* <div className="d-flex">
        <Header />
        <Auth />
      </div> */}
      <div className="rightlayoutinner dashboardH"></div>
      <div className="userHeader">
        <h3>{t("MySelection")}</h3>
      </div>
      <div className="page">
        <div className="rightsidedata">
          <div
            style={{
              marginTop: "10px",
            }}
          >
            <>
              <div
                className={cookiedata === "en" ? "div_maintb" : "div_maintbAr"}
              >
                <ScrollContainer>
                  <table className="muSelectedTable">
                    <thead>
                      <tr>
                        <th>{t("CompetitionName")}</th>
                        <th className={cookiedata === "en" ? "lb" : "rb"}>
                          {t("Date")}
                        </th>

                        <th>{t("HorseName")}</th>
                        <th>{t("HorseNo")}</th>
                        <th>{t("RaceNo")}</th>
                        <th>{t("race_course")}</th>
                        <th>{t("Country1")}</th>

                        <th>
                          {t("Race")} {t("Name")}
                        </th>
                        <th>{t("RaceType")}</th>
                        {/* 
                        <th>{t("Point")}</th>
                        <th>{t("BonusPoint")}</th> */}
                        <th className={cookiedata === "en" ? "rb" : "lb"}>
                          {t("Type")}
                        </th>

                        {/* <th>{t("Nationality")}</th> */}
                        {/* <th>{t("Nationality")}</th>
                        <th>{t("Nationality")}</th>
                        <th>{t("Nationality")}</th> */}
                      </tr>
                    </thead>
                    <tbody>
                      {singleUser.CompetitionSubscriberIDData ? (
                        singleUser.CompetitionSubscriberIDData.map((item) => {
                          return (
                            <tr>
                              <td
                                style={{
                                  maxHeight: "400px",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {cookiedata === "en" ? (
                                  <>
                                    {item.CompetitionIDData ? (
                                      item.CompetitionIDData.NameEn
                                    ) : (
                                      <></>
                                    )}
                                  </>
                                ) : (
                                  <>
                                    {item.CompetitionIDData ? (
                                      item.CompetitionIDData.NameAr
                                    ) : (
                                      <></>
                                    )}
                                  </>
                                )}
                              </td>
                              <td>
                                <Moment format="YYYY/MM/DD">
                                  {item.CompetitionRaceIDData ? (
                                    item.CompetitionRaceIDData.Day
                                  ) : (
                                    <>0</>
                                  )}
                                </Moment>
                              </td>
                              <td
                                style={{
                                  maxHeight: "400px",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {cookiedata === "en" ? (
                                  <>
                                    {" "}
                                    {item.CompetitionIDData ? (
                                      item.CompetitionIDData
                                        .CompetitionTypeData ? (
                                        item.CompetitionIDData
                                          .CompetitionTypeData.NameEn
                                      ) : (
                                        <></>
                                      )
                                    ) : (
                                      <></>
                                    )}
                                  </>
                                ) : (
                                  <>
                                    {item.CompetitionIDData ? (
                                      item.CompetitionIDData
                                        .CompetitionTypeData ? (
                                        item.CompetitionIDData
                                          .CompetitionTypeData.NameAr
                                      ) : (
                                        <></>
                                      )
                                    ) : (
                                      <></>
                                    )}
                                  </>
                                )}
                              </td>
                              <td
                                style={{
                                  maxHeight: "400px",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {cookiedata === "en" ? (
                                  <>
                                    {item.CompetitionHorseIDData ? (
                                      item.CompetitionHorseIDData.NameEn
                                    ) : (
                                      <></>
                                    )}
                                  </>
                                ) : (
                                  <>
                                    {item.CompetitionHorseIDData ? (
                                      item.CompetitionHorseIDData.NameAr
                                    ) : (
                                      <></>
                                    )}
                                  </>
                                )}
                              </td>
                              <td>{item.Rank}</td>
                              <td>
                                {item.CompetitionRaceIDData ? (
                                  item.CompetitionRaceIDData.RaceNumber
                                ) : (
                                  <>0</>
                                )}
                              </td>
                              <td
                                style={{
                                  maxHeight: "400px",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {cookiedata === "en" ? (
                                  <>
                                    {item.CompetitionRaceIDData ? (
                                      item.CompetitionRaceIDData.RaceCourseData
                                        .TrackNameEn
                                    ) : (
                                      <></>
                                    )}
                                  </>
                                ) : (
                                  <>
                                    {item.CompetitionRaceIDData ? (
                                      item.CompetitionRaceIDData.RaceCourseData
                                        .TrackNameAr
                                    ) : (
                                      <></>
                                    )}
                                  </>
                                )}
                              </td>
                              <td
                                style={{
                                  maxHeight: "400px",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {cookiedata === "en" ? (
                                  <>
                                    {item.CompetitionRaceIDData ? (
                                      item.CompetitionRaceIDData
                                        .RaceCourseData ? (
                                        item.CompetitionRaceIDData
                                          .RaceCourseData
                                          .NationalityDataRaceCourse.NameEn
                                      ) : (
                                        <>- </>
                                      )
                                    ) : (
                                      <></>
                                    )}
                                  </>
                                ) : (
                                  <>
                                    {item.CompetitionRaceIDData ? (
                                      item.CompetitionRaceIDData
                                        .RaceCourseData ? (
                                        item.CompetitionRaceIDData
                                          .RaceCourseData
                                          .NationalityDataRaceCourse.NameAr
                                      ) : (
                                        <>- </>
                                      )
                                    ) : (
                                      <></>
                                    )}
                                  </>
                                )}
                              </td>
                              <td
                                style={{
                                  maxHeight: "400px",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {cookiedata === "en" ? (
                                  <>
                                    {item.CompetitionRaceIDData ? (
                                      item.CompetitionRaceIDData
                                        .RaceNameModelData.NameEn
                                    ) : (
                                      <></>
                                    )}
                                  </>
                                ) : (
                                  <>
                                    {item.CompetitionRaceIDData ? (
                                      item.CompetitionRaceIDData
                                        .RaceNameModelData.NameAr
                                    ) : (
                                      <></>
                                    )}
                                  </>
                                )}
                              </td>

                              <td
                                style={{
                                  maxHeight: "400px",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                }}
                                className={cookiedata === "en" ? "rb" : "lb"}
                              >
                                {cookiedata === "en" ? (
                                  <>
                                    {item.CompetitionRaceIDData ? (
                                      truncateRaceType(item.CompetitionRaceIDData
                                        .RaceTypeModelData.NameEn)
                                    ) : (
                                      <></>
                                    )}
                                  </>
                                ) : (
                                  <>
                                    {item.CompetitionRaceIDData ? (
                                      item.CompetitionRaceIDData
                                        .RaceTypeModelData.NameAr
                                    ) : (
                                      <></>
                                    )}
                                  </>
                                )}
                              </td>
                              {/* <td>{item.Point ? item.Point : <>0</>}</td> */}

                              {/* <td>
                                {item.BonusPoint ? item.BonusPoint : <>0</>}
                              </td> */}
                            </tr>
                          );
                        })
                      ) : (
                        <></>
                      )}
                    </tbody>
                  </table>
                </ScrollContainer>
              </div>
            </>
          </div>
        </div>
      </div>
      <Footer />
      <Copyrights />
    </Fragment>
  );
};

export default MySelection;
